import common from './ar/common.json';
import student from './ar/student.json';
import deal from './ar/deal.json';
import application from './ar/application.json';
import institute from './ar/institute.json';
import course from './ar/course.json';
import invoice from './ar/invoice.json';
import source from './ar/source.json';
import subagent from './ar/subagent.json';
import channel from './ar/channel.json';
import field from './ar/field.json';
import role from './ar/role.json';
import company from './ar/company.json';
import product from './ar/product.json';
import template from './ar/template.json';
import report from './ar/report.json';
import auth from './ar/auth.json';
import user from './ar/user.json';
import bank from './ar/bank.json';
import form from './ar/form.json';
import dashboard from './ar/dashboard.json';
import payment from './ar/payment.json';
import dispute from './ar/dispute.json';
import contract from './ar/contract.json';
import profile from './ar/profile.json';
import team from './ar/team.json';
import recentimports from './ar/recentimports.json';

const ar = {
  ...common,
  ...student,
  ...deal,
  ...application,
  ...institute,
  ...course,
  ...invoice,
  ...source,
  ...subagent,
  ...channel,
  ...field,
  ...role,
  ...company,
  ...product,
  ...template,
  ...report,
  ...auth,
  ...user,
  ...bank,
  ...form,
  ...dashboard,
  ...payment,
  ...dispute,
  ...contract,
  ...profile,
  ...team,
  ...recentimports
};

export default ar;
